import aboutContent from "./content/about.json";

export const aboutMock = {
  name: "about-us",
  layoutType: 1,
  areasList: [
    {
      id: "about-1",
      name: "about-content",
      componentName: "Comp:AboutPage",
      content: JSON.stringify(aboutContent),
    },
  ],
};
